import React from "react";
import { Navigate } from "react-router-dom";
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    // انقله لصفحة تسجيل الدخول
    return <Navigate to="/admin/login" replace />;
  }

  // عرض الصفحة المطلوبة
  return children;
};

export default ProtectedRoute;
